import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import staheliLogo from '../assets/images/StaheliWestLogo.png';
import apexLogo from '../assets/images/APEXAGLOGO.png';
import agromecanicaLogo from '../assets/images/AgroMecanicaLogo.png';

const ManufacturerPartnerships: React.FC = () => {
  const { t } = useTranslation();

  const partnerships = [
    {
      id: 'staheli-west',
      name: 'Staheli West',
      logo: staheliLogo,
      type: 'dealer',
    },
    {
      id: 'apex-ag',
      name: 'APEX Ag',
      logo: apexLogo,
      type: 'dealer',
    },
    {
      id: 'agromecanica',
      name: 'AgroMecánica Calchín',
      logo: agromecanicaLogo,
      type: 'service',
    },
  ];

  return (
    <section className='py-16 bg-gray-50 dark:bg-gray-900/50'>
      <div className='container mx-auto px-6'>
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className='text-center mb-12'
        >
          <h2 className='text-3xl md:text-4xl font-bold mb-4 text-accent'>
            {t('partnerships.title')}
          </h2>
          <p className='text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto'>
            {t('partnerships.subtitle')}
          </p>
        </motion.div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto'>
          {partnerships.map((partnership, index) => (
            <motion.div
              key={partnership.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className='relative bg-white dark:bg-black/60 rounded-xl shadow-lg p-8 border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-shadow duration-300'
            >
              {/* Partnership Badge */}
              <div className='absolute top-4 right-4'>
                <div
                  className={`px-3 py-1 rounded-full text-xs font-bold text-white shadow-md ${
                    partnership.type === 'dealer'
                      ? 'bg-blue-500'
                      : 'bg-green-500'
                  }`}
                >
                  {partnership.type === 'dealer'
                    ? t('partnerships.authorizedDealer')
                    : t('partnerships.servicePartner')}
                </div>
              </div>

              {/* Logo Container */}
              <div className='flex items-center justify-center mb-6 h-24'>
                <img
                  src={partnership.logo}
                  alt={partnership.name}
                  className='max-h-full max-w-full object-contain filter dark:brightness-110'
                />
              </div>

              {/* Partnership Info */}
              <div className='text-center'>
                <h3 className='font-bold text-xl text-gray-900 dark:text-white mb-2'>
                  {partnership.name}
                </h3>
                {partnership.type === 'dealer' && (
                  <p className='text-sm text-gray-600 dark:text-gray-400'>
                    {t('partnerships.dealerDescription')}
                  </p>
                )}
                {partnership.type === 'service' && (
                  <p className='text-sm text-gray-600 dark:text-gray-400'>
                    {t('partnerships.serviceDescription')}
                  </p>
                )}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust Statement */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className='text-center mt-12 bg-accent/10 rounded-2xl p-8 border border-accent/20'
        >
          <p className='text-lg font-medium text-gray-800 dark:text-gray-200 max-w-3xl mx-auto'>
            {t('partnerships.trustStatement')}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ManufacturerPartnerships;
